interface OptionsSummaryLabelProps {
  title: string
  label: string[] | string
}

// Internal component for a single option label(s)
const OptionsSummaryLabel = ({ title, label }: OptionsSummaryLabelProps) => {
  // No label
  if (!label) {
    return <strong>{title}</strong>
  }

  return (
    <>
      <strong>{title} : </strong>
      {Array.isArray(label)
        ? label
            .map((subLabel, index) =>
              Array.isArray(subLabel) ? subLabel[1] : subLabel
            )
            .join(' - ')
        : label}
    </>
  )
}
export default OptionsSummaryLabel
